const translations: Record<string, string> = {
  "A.TR Movement Certificate": "A.TR Circulation Certificate",
  "ABD": "United States",
  "ADIM": "STEP",
  "Adres": "Address",
  "Air Freight": "Air Freight",
  "airfreight": "Air Freight",
  "Aktif": "Active",
  "Almanya": "Germany",
  "Ambalaj": "Packaging",
  "Ambalajlama": "Packaging",
  "Ana Sayfa": "Home",
  "Ana Sayfaya Dön": "Back to Home",
  "Anlatıyor": "Stories",
  "Aydınlık Mod": "Light Mode",
  "Beyanname": "Declaration",
  "Birlikte": "Together",
  "Boyutlar": "Dimensions",
  "Boyutunda": "Dimension",
  "Bülten": "Newsletter",
  "Countries where A.TR Movement Certificate will be issued": "Countries Eligible for A.TR Circulation Certificate",
  "Dekorasyon": "Decoration",
  "Demiryolu": "Railway",
  "Denizyolu": "Sea Freight",
  "Depo": "Warehouse",
  "Destek": "Support",
  "Dünyaya açılan": "A gateway to the world",
  "Dünyaya Açılan": "A Gateway to the World",
  "E-posta": "Email",
  "e-posta": "e-mail",
  "E-posta *": "Email *",
  "Elektronik": "Electronic",
  "E-Ticaret": "E-Commerce",
  "Entegrasyon": "Integration",
  "Filo & Teknoloji": "Fleet & Technology",
  "Filomuz": "Our fleet",
  "Fransa": "France",
  "Giriş Yap": "Log In",
  "Hakkımızda": "About Us",
  "Hemen Ara": "Call Now",
  "hesapla": "calculate",
  "Hesapla": "Calculate",
  "hissedeceksiniz.": "you will feel it.",
  "Hizmet": "Service",
  "Hizmetler": "Services",
  "Hizmetleri İncele": "Browse Services",
  "Hizmetleri Keşfet": "Explore Services",
  "Hizmetlerimiz": "Our services",
  "Hollanda": "Netherlands",
  "İletişim": "Contact",
  "Kadro": "Staff",
  "Kapsam": "Scope",
  "Karanlık Mod": "Dark Mode",
  "Karayolu": "Road Freight",
  "Kargonuzu": "Your Cargo",
  "Koli": "Box",
  "Konteyner": "Container",
  "Kurumsal": "Corporate",
  "KVKK": "PDPL",
  "Lojistik": "Logistics",
  "Muafiyet": "Exemption",
  "Name Surname": "Full Name",
  "Name Surname *": "Full Name *",
  "Nereden": "From",
  "Nereye": "To",
  "Notlar": "Notes",
  "opening to the world": "Your gateway to the world",
  "Organik": "Organic",
  "Otomasyon": "Automation",
  "Paket": "Package",
  "Paketleme": "Packaging",
  "Parsiyel": "Partial",
  "Pazaryeri": "Marketplace",
  "Pazaryerlerine": "to marketplaces",
  "Referanslar": "References",
  "Sigorta": "Insurance",
  "Sorgula": "Track",
  "Spor": "Sports",
  "Tahmini": "Estimated",
  "takip": "tracking",
  "Tam": "Full",
  "Teklif": "Offer",
  "Teklif Al": "Get a Quote",
  "Teknoloji": "Technology",
  "Tekstil": "Textile",
  "Telefon": "Telephone",
  "Teslimat": "Delivery",
  "Turgut Özal Mah. 55.Sk. No:47/3": "Turgut Özal Mah. 55.Sk. No:47/3",
  "Türkiye": "Turkey",
  "Tümünü Gör": "View All",
  "Uzman": "Expert",
  "veya": "or",
  "What is A.TR Movement Certificate?": "What Is an A.TR Circulation Certificate?",
  "Yolda": "on the road",
  "Ücretsiz Danışmanlık": "Free Consultation",
  "Ücretsiz Teklif Al": "Get a Free Quote",
  "Üye Ol": "Sign Up"
};

export default translations;
